import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  test() {
	  alert('yes');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts